export default "__VITE_ASSET__CS$4D3x1__";